import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card'
import { Button } from '../../ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table'
import { Calendar } from 'lucide-react'
import { SimpleEvent } from '../../../model/Event'
import { DateTime } from 'luxon'

interface ClientEventsSectionProps {
  events: SimpleEvent[]
}

const formatDate = (date: Date | string | undefined) => {
  if (!date) return '-'
  try {
    const dateObj = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date)
    return dateObj.toFormat('MMM dd, yyyy')
  } catch {
    return '-'
  }
}

export const ClientEventsSection: React.FC<ClientEventsSectionProps> = ({ events }) => {
  const navigate = useNavigate()

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          Associated Events
        </CardTitle>
        <CardDescription>Events belonging to this client</CardDescription>
      </CardHeader>
      <CardContent>
        {events.length === 0 ? (
          <p className="text-center py-6 text-muted-foreground">
            No events found for this client
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Start Date</TableHead>
                <TableHead>End Date</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {events.map((event) => (
                <TableRow key={event.id}>
                  <TableCell className="font-medium">{event.name}</TableCell>
                  <TableCell>{formatDate(event.startDate)}</TableCell>
                  <TableCell>{formatDate(event.endDate)}</TableCell>
                  <TableCell className="text-right">
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => navigate(`/event/${event.id}/config`)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
